import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score/edit/$projectionId')({
  beforeLoad: () => getTitleContextSlice('Edit Factors'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
});
